import PropTypes from 'prop-types';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { isGroupOffer } from '@@viewEnums';
import GroupHealthConfirmationModal from './GroupHealthConfirmationModal';
import IndividualConfirmationModal from './IndividualConfirmationModal';

/**
 * Wrapper component that renders the appropriate confirmation modal based on offer type.
 * - For group offers (GROUP_HEALTH, GROUP_PROTECTION): Shows GroupHealthConfirmationModal (decision maker contact)
 * - For other offers: Shows IndividualConfirmationModal (customer contact)
 */
const ConfirmationModal = ({
  isDisplayed,
  phoneIndicatives,
  internationalPhoneIndicatives,
  confirm,
  getMiddleText,
  close,
  form,
  offerCode: offerCodeProp
}) => {
  const { context } = useProcess();
  const offerCode = offerCodeProp || context?.offerCode;

  if (isGroupOffer(offerCode)) {
    return (
      <GroupHealthConfirmationModal
        isDisplayed={isDisplayed}
        phoneIndicatives={phoneIndicatives}
        confirm={confirm}
        getMiddleText={getMiddleText}
        close={close}
        form={form}
      />
    );
  }

  return (
    <IndividualConfirmationModal
      isDisplayed={isDisplayed}
      phoneIndicatives={phoneIndicatives}
      internationalPhoneIndicatives={internationalPhoneIndicatives}
      confirm={confirm}
      getMiddleText={getMiddleText}
      close={close}
      form={form}
    />
  );
};

ConfirmationModal.propTypes = {
  isDisplayed: PropTypes.bool,
  phoneIndicatives: PropTypes.array,
  internationalPhoneIndicatives: PropTypes.array,
  confirm: PropTypes.func,
  getMiddleText: PropTypes.func,
  close: PropTypes.func,
  form: PropTypes.object,
  offerCode: PropTypes.string
};

export default ConfirmationModal;
